import React from 'react';
import Container from '../Container';
import cn from 'classnames';
import { ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

type Item = {
  label: string | React.ReactNode;
  url?: string;
};

interface BreadcrumbProps {
  items: Item[];
  className?: string;
  onNavigate?: (path: string) => void;
}

export const Separator = () => {
  return (
    <span className="mx-[10px]">
      <ChevronRightIcon className="h-[16px] w-[11px] stroke-[#257DE5]" />
    </span>
  );
};

const Breadcrumb = ({ items, className, onNavigate }: BreadcrumbProps) => {
  return (
    <Container>
      <div className={cn('col-span-12 my-sh-30 lg:col-start-3 lg:col-end-11', className)}>
        <nav className="flex items-center justify-start" aria-label="Breadcrumb">
          <ol className="!m-0 flex flex-wrap !pl-0">
            <li key="home" className="mr-[10px] flex items-center">
              {onNavigate ? (
                <button onClick={() => onNavigate('/')} className="border-none bg-transparent p-0">
                  <img src="/breadcrumb-home.svg" alt="breadcrumb-home" width={12} height={12} />
                </button>
              ) : (
                <Link to="/">
                  <img src="/breadcrumb-home.svg" alt="breadcrumb-home" width={12} height={12} />
                </Link>
              )}
            </li>
            {items.map((item, index) => (
              <li key={index} className="flex items-center ">
                {index > 0 && <Separator />}
                {item?.url ? (
                  onNavigate ? (
                    <button
                      onClick={() => onNavigate(item.url!)}
                      className="inline-block w-fit max-w-[150px] overflow-hidden text-ellipsis text-nowrap border-none bg-transparent p-0 font-cadiz text-sh-xxxs  capitalize md:max-w-[400px]">
                      {item.label}
                    </button>
                  ) : (
                    <a
                      href={item.url}
                      className="inline-block w-fit max-w-[150px] overflow-hidden text-ellipsis text-nowrap font-cadiz text-sh-xxxs capitalize md:max-w-[400px]">
                      {item.label}
                    </a>
                  )
                ) : (
                  <span className="inline-block w-fit max-w-[150px] overflow-hidden text-ellipsis text-nowrap font-cadiz text-sh-xxxs capitalize md:max-w-[400px] lg:max-w-[650px]">
                    {item.label}
                  </span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
    </Container>
  );
};

export default Breadcrumb;
